import { stringify } from 'qs';
import request, { format } from '@/utils/request';

export async function queryProvince() {
  return request('/api/geographic/province');
}

export async function queryCity(province) {
  return request(`/api/geographic/city/${province}`);
}
// 获取所有省城市行政区
export async function fetchAllLocation(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/base/gis/districtTree?onlyMainland=true&${params}`));
}
export async function fetchDistrictList(payload = {}) {
  const search = new URLSearchParams(payload).toString();
  return format(request(`/mdc/base/gis/districts?${search}`));
}
// 根据地址和城市获取经纬度
export async function fetchNewCoordinates(payload = {}) {
  const { address, cityId, cityName, districtName } = payload;
  if (!address) return;
  return format(
    request(
      `/mdc/base/gis/gc?address=${encodeURIComponent(
        address
      )}&cityName=${cityName}&districtName=${districtName}`
    )
  );
}
export async function fetchTransformCity(payload = {}) {
  const search = new URLSearchParams({
    key: 'md045d0796494a1db06666b12915317w',
    ...payload,
  }).toString();
  return format(request(`https://lbsapi.meituan.com/v1/transformcitytype?${search}`), null, {
    unwrap: true,
  });
}
export async function fetchAddressIntegrity(payload = {}) {
  const { address, cityName, districtName } = payload;
  return format(
    request(
      `https://lbsapi.meituan.com/v1/integrity?key=md045d0796494a1db06666b12915317w&scenario=BIZ&address=${cityName ||
        ''}${districtName || ''}${address}&city=${cityName}`
    ),
    null,
    { unwrap: true }
  );
}
// 根据经纬度获取地址
export async function fetchNewAddressByCoordinates(payload = {}) {
  const { latitude, longitude } = payload;
  return format(
    request(`/mdc/base/gis/rgc?latitude=${Number(latitude)}&longitude=${Number(longitude)}`)
  );
}

// 根据Ip获取当前经纬度
export async function fetchIPLocation() {
  // 将默认错误提示关闭
  return format(request('/mdc/base/gis/ipLocate'), () => {});
}
